/* eslint-disable no-case-declarations */
/* eslint-disable max-len */
/* eslint-disable no-console */
import { Button, Dialog, DialogActions, DialogContent, Grid, Stack } from '@mui/material';
import React, { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { feedActionContext } from '../../../..';
import Loading from '../../../../../../components/Common/Loaders/FullWidthLoader/Loading';
import NewDialogPopup from '../../../../../../components/Common/NewDialogPopup/NewDialogPopup';
import { LanguageContext } from '../../../../../../libs/Context';
import useFeedApproval from '../CustomHooks/useFeedApproval';
import ApprovalNotice from '../Components/ApprovalNotice';
import { catchErr, convertDOMToImage, newUploadFiles, s3DeleteNew } from '../../../../../../libs/HelperContent';
import { createNewFeed, repostFeedsAPI, upatedFeedsAPI } from '../../../../../actions/feeds_actions_new';
import RepostCard from '../../FeedCards/Components/RepostCard';
import CreateFeedHeader from './CreateFeedHeader';
import { useGetFeedApi } from './CustomHooks/useGetRelations';
import FooterActions from './DialogActions';
import CreationContent from './DialogContent';
import { useNavigate } from 'react-router-dom';
import { getDepartments } from '../../../../../../containers/actions/department_actions';
import useGetConfigs from '../../../../../../libs/useGetConfigs';

export const createFeedContext = createContext<any>({});

type RequestType = 'repost' | 'editFeeds' | 'driveUpload' | undefined;

interface BaseProps {
	OpenPop: boolean;
	handleClosePop: () => void;
	handleRepostCallback?: (data: any) => void; // only required when requestT is repost
	handleEditCallBack?: (obj: any) => void;
}

interface RepostProps extends BaseProps {
	requestT: 'repost' | 'editFeeds';
	editData: any;
	externalFile?:never;
}

interface DriveUploadProps extends BaseProps {
	requestT: 'driveUpload';
	externalFile: Array<{
		type: string;
		[key: string]: any;
	}>;
	editData?: never;
}

interface NoRequestProps extends BaseProps {
	requestT?: undefined;
	editData?: never;
	externalFile?: never;
}

type Props = RepostProps | DriveUploadProps | NoRequestProps;

const CreationFieldPopUp = (props:Props) =>
{
	const { OpenPop, handleClosePop, editData, requestT, externalFile, handleRepostCallback, handleEditCallBack } = props;
	const navigate = useNavigate();
	// const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
	const { language } = useContext(LanguageContext);
	const [ cancelPopup, setCancelPopup ] = useState(false);
	const userData = useSelector((state:any) => state?.mysession?.session);
	// const userConfigs = useSelector((state:any) => state?.mysession?.userConfigs);
	const relationsRef = useRef<any>([]);
	const { requiresApproval, isFeedsAdmin } = useFeedApproval();
	const [ loading, setLoading ] = useState(false);
	const canPostAsCompany = isFeedsAdmin;
	const wasFeedCreatedByCompany = editData?.createdBy === userData?.companyId;
	const { getCompanyConfigurations, getUserConfigurations } = useGetConfigs();
	const departmentsRef = useRef<any>([]);

	console.log('requestT***', requestT);

	let initialFooterAct: any = null;

	if (requestT === 'driveUpload')
	{
		initialFooterAct = 'image';
	}
	const [ footerAction, setFooterAction ] = useState<any>(initialFooterAct);

	let initialFeedAs: string;

	if (requestT === 'editFeeds')
	{
		initialFeedAs = wasFeedCreatedByCompany ? 'company' : 'self';
	}
	else
	{
		initialFeedAs = canPostAsCompany ? 'company' : 'self';
	}

	const [ createFeedAs, setCreateFeedAs ] = useState<any>(initialFeedAs);
	const { handleFeedAction } = useContext(feedActionContext);
	const internalEmpl = {
		relation   : 'company internal employees',
		relationId : `${userData?.companyId}-employee`
	};
	const isReposting = requestT === 'repost' || Boolean(editData?.repostObj?.feedId);

	const initialFeedData = useMemo(() =>
	{
		const relations = [ internalEmpl ];

		switch (requestT)
		{
			case ('editFeeds'): {
				// Wrap the case block with `{}` to avoid lexical declaration issue
				const updatedData: any = {
					media       : editData?.media?.map((mediaObj) => ({ ...mediaObj, tab: 1 })),
					description : editData?.description,
					shareTo     : editData?.shareTo,
					link        : editData?.link
				};

				const isPollAdded = editData?.feedType === 'poll';
				const isOccasionAdded = editData?.feedType === 'occasion';

				if (editData?.taggedPeople) updatedData.taggedPeople = editData?.taggedPeople;
				if (editData?.feedType) updatedData.feedType = editData?.feedType;
				if (editData?.scheduledAt) { updatedData.schedule = true; updatedData.scheduledAt = editData?.scheduledAt; }

				if (isPollAdded)
				{
					const poll = { ...editData?.pollData };

					poll.options = editData?.pollData?.options.map((opt) => ({ option: opt.option }));
					updatedData.poll = poll;
				}
				else if (isOccasionAdded) updatedData.occasion = editData.occasion;

				return updatedData;
			}
			case ('driveUpload'): {
				return () =>
				{
					if (externalFile.length > 0 && [ 'video', 'application' ].includes(externalFile[0]?.type?.split('/')[0]))
					{
						return {
							relations,
							media : externalFile
						};
					}
					else
					{
						return { relations };
					}
				};
			}
			default: {
				return { relations };
			}
		}
	}, [ requestT ]);

	const [ createFeed, setCreateFeed ] = useState<any>(initialFeedData);
	const parser = new DOMParser();
	const isDescriptionAdded = useMemo(() =>
	{
		const doc = parser.parseFromString(createFeed?.description ?? '', 'text/html');
		const text:any = doc.body.textContent?.trim();

		return Boolean(text);
	}, [ createFeed?.description ]);
	const disableFeedPost = !isDescriptionAdded &&
							!createFeed?.media?.length &&
							!createFeed?.link &&
							!createFeed?.occasion &&
							!createFeed?.poll?.question && requestT !== 'repost';

	// console.log('createFeed***', createFeed);

	const disablePost = useMemo(() =>
	{
		const editMediaUrls = editData?.media?.map((item) => item.url);
		const createFeedUrls = createFeed?.media?.map((item) => item.url);

		const comparePollData = (editFeed, createData) =>
		{
			const normalizedEditOptions = editFeed?.pollData?.options?.map(({ option }) => ({ option }));

			return (
				editFeed?.pollData?.linkedInDuration === createData?.poll?.linkedInDuration &&
				JSON.stringify(normalizedEditOptions) === JSON.stringify(createData?.poll?.options) &&
				editFeed?.pollData?.question === createData?.poll?.question);
		};

		const isMatch = comparePollData(editData, createFeed);
		const currRelations = createFeed?.relations?.map((item) => item?.relationId).sort();
		const prevSelectedRelationsList = relationsRef?.current?.filter((item) => editData?.shareTo?.includes(item?.relationId));
		// const prevSelectedRelationsList = editData?.shareTo?.filter((dataD) => createFeed?.relations?.some((reltn) => reltn?.relationId === dataD?.relationId));
		// const prevSelectedRelationsList = relationsRef?.current?.filter((dataD) => editData?.relations?.some((reltn) => reltn?.relationId === dataD?.relationId));

		const oldRelations = prevSelectedRelationsList?.map((item) => item?.relationId).sort();

		return (
			parser.parseFromString(createFeed?.description, 'text/html').body.textContent?.trim() ===
			parser.parseFromString(editData?.description, 'text/html').body.textContent?.trim() &&
			JSON.stringify(editMediaUrls) === JSON.stringify(createFeedUrls) &&
			JSON.stringify(createFeed?.taggedPeople) === JSON.stringify(editData?.taggedPeople) &&
			JSON.stringify(currRelations) === JSON.stringify(oldRelations) &&
			isMatch &&
			!createFeed.occasion &&
			editData?.isActive
		);
	}, [ editData, createFeed?.media, createFeed?.description, createFeed?.taggedPeople, createFeed?.occasion, createFeed?.poll, createFeed?.relations, relationsRef.current ]);
	const isSchedule = createFeed?.scheduledAt;

	const cursorPositionRef = useRef(0);
	const excludedS3KeysRef = useRef([]);
	const getFeedRelations = useGetFeedApi();

	// const userDataDetails:any = {
	// 	firstName    : (userFullName(userData)),
	// 	profileImage : (roleCondition(userData?.empRole))
	// 		? userData?.companyData?.profileImage
	// 		: userData?.profileImage,
	// 	industryTypes  : userData?.companyData?.industryTypes,
	// 	companyName    : userData?.companyData?.companyName,
	// 	thumbnailImage : (roleCondition(userData?.empRole))
	// 		? userData?.companyData?.thumbnailImage
	// 		: userData?.thumbnailImage
	// };

	const getTagPeople = async () =>
	{
		const { taggedPeople } = createFeed ?? {};
		const tagPeopleData = taggedPeople?.length > 0 	? taggedPeople : null;

		return tagPeopleData ?? null;
	};

	const getOccassion = async () =>
	{
		const { occasion } = createFeed ?? {};

		if (!occasion) return null;

		return {
			type           : occasion?.type ?? '',
			title          : occasion?.title ?? '',
			text           : occasion?.text ?? '',
			employees      : occasion?.employees ?? [],
			templateUrlWeb : occasion?.templateUrlWeb ?? '',
			templateUrlMob : occasion?.templateUrlMob,
			templateId     : occasion?.templateId ?? 0
		};
	};

	const occasionMedia = async () =>
	{
		if (createFeed?.capturedDOM)
		{
			try
			{
				setLoading(true);
				const path = `${userData?.companyId}/feed`;
				const element = createFeed?.capturedDOM;
				const imageUrl = await convertDOMToImage(element);
				const upload = await newUploadFiles([ imageUrl ], path);

				return upload;
			}
			catch (error)
			{
				console.error('Error in occasionMedia:', error);
				setLoading(false);

				return null;
			}
		}
		else
		{
			console.warn('No capturedDOM found in createFeed.');
			setLoading(false);

			return null;
		}
	};

	const getMedia = async () =>
	{
		const sendKeys = await createFeed?.media?.map((mediaD) =>
		{
			return {
				key   : mediaD?.key,
				name  : mediaD?.name,
				title : mediaD?.title,
				type  : mediaD?.type,
				url   : mediaD?.url,
				size  : mediaD?.size,
				...(mediaD?.thumbnail ? { thumbnail: mediaD?.thumbnail } : {}),
				...(mediaD?.videotext ? { videotext: mediaD?.videotext } : {}),
				...(mediaD?.width ? { width: mediaD?.width } : {}),
				...(mediaD?.height ? { height: mediaD?.height } : {})
			};
		});

		return sendKeys;
	};

	const handlePost = async (isActive:boolean = true) =>
	{
		if (disableFeedPost)
		{
			// toast.error('Content is required to create a post.');
			toast.error(language?.CreateFilePopErr);

			return;
		}
		if (createFeed?.occasion)
		{
			const { text, title } = createFeed?.occasion ?? {};

			if (!text || !title)
			{
				let message = '';

				if (!text && !title)
				{
					// message = 'Both greeting message and title are required!';
					message = `${language?.greetNdtitleErr}`;
				}
				else if (!text)
				{
					// message = "Oops! You've not entered your greeting message!";
					message = `${language?.greetngErr}`;
				}
				else
				{
					// message = "Oops! You've not entered the title!";
					message = `${language?.titleNotEnteredErr}`;
				}

				toast.error(message);
				setLoading(false);

				return;
			}
		}

		const isInternalEmployeesSelected = createFeed?.relations?.some((dataD) => dataD?.relationId === relationsRef?.current?.find((r) => r?.relation === 'company internal employees')?.relationId);
		const isAllRelationsSelected = createFeed?.relations?.filter((r) => typeof r !== 'string')?.length === relationsRef?.current?.length;

		const isPublic = isInternalEmployeesSelected && isAllRelationsSelected;

		if (!loading)
		{
			const { description } = createFeed; // link removed as per the SQ

			setLoading(true);

			let htmlString = '';

			if (description !== '' && createFeed?.hasOwnProperty('description'))
			{
				let trimDes = description?.replace(/^(<p>\s*<br>\s*<\/p>\s*)+/, '');

				trimDes = trimDes?.replace(/(<p>\s*<br>\s*<\/p>\s*)+$/, '');

				const doc = parser.parseFromString(trimDes, 'text/html');

				const ps = doc.querySelectorAll('p');

				ps.forEach((p) =>
				{
					const imgs = p?.querySelectorAll('img');

					imgs.forEach((img) => img.remove());

					if (p?.textContent && !p.textContent.trim())
					{
						if (p?.parentNode)
						{
							p.parentNode.removeChild(p);
						}

						return;
					}

					const urlRegEx = /https?:\/\/[^\s/$.?#].[^\s]*/g;

					p.innerHTML = p.innerHTML.replace(urlRegEx, (url) =>
					{
						const anchorTag = document.createElement('a');

						anchorTag.href = url.replace(/"/g, '');
						anchorTag.textContent = url.replace(/"/g, '');
						anchorTag.target = '_blank';
						anchorTag.style.color = 'blue';
						const anchorTagHTML = anchorTag.outerHTML;

						return anchorTagHTML;
					});
				});
				htmlString = doc.documentElement.innerHTML;
			}

			const body: any = {
				isActive,
				self : createFeedAs === 'self',
				// userData : userDataDetails,
				isPublic,
				...(isPublic && { isPublic: true }),
				...(createFeed?.hasOwnProperty('scheduledAt') && { schedule: true, scheduledAt: createFeed.scheduledAt }),
				...(createFeed?.taggedPeople?.length > 0 ? { taggedPeople: await getTagPeople() } : {}),
				...(createFeed?.socialMedia?.length > 0 ? { socialMedia: createFeed?.socialMedia } : {})
			};

			if (isActive && !editData?.isActive) body.posted = true;

			const query = {
				uid     : userData?.userId,
				comid   : userData?.companyId,
				empRole : userData?.empRole,
				role    : userData?.role
			};

			// Check and set feed type and specific properties for 'occasion' or 'poll'
			if (createFeed?.occasion && Object.keys(createFeed.occasion).length > 0)
			{
				const [ media, occasionData ] = await Promise.all([
					occasionMedia(),
					getOccassion()
				]);

				Object.assign(body, {
					feedType    : 'occasion',
					media,
					occasion    : occasionData ?? {},
					description : (isDescriptionAdded) ? htmlString : ''
				});
			}
			else if (createFeed?.poll && Object.keys(createFeed.poll).length > 0)
			{
				body.feedType = 'poll';
				body.pollData = { ...createFeed?.poll };
				body.description = (isDescriptionAdded) ? htmlString : '';
			}
			else
			{
				body.description = (isDescriptionAdded) ? htmlString : '';
				if (createFeed.media?.length >= 0)
				{
					body.media = await getMedia();
				}
			}

			// Handle relations if they don't match the reference length
			if (createFeed?.relations?.length > 0 && !isPublic && userData?.role !== 'individual')
			{
				body.includes = createFeed.relations.map((item: any) => item?.relation || item);
				body.shareTo = createFeed.relations.map((item: any) => item?.relationId || item);
			}

			// Handle edit and remove tagged peoples cases
			if (createFeed?.taggedPeople?.length <= 0 && editData?.taggedPeople?.length > 0)
			{
				body.taggedPeople = [];
			}

			// Handle edit and repost cases
			if (requestT === 'editFeeds' && editData?._id)
			{
				Object.assign(body, { isEdited: editData?.isActive && isActive, feedId: editData?._id });
			}
			else if (isReposting && editData?._id)
			{
				body.feedId = editData?._id;
			}

			try
			{
				let res:any;

				if (requestT === 'editFeeds')
				{
					const bodyKeys = Object.keys(body);

					bodyKeys.forEach((key) =>
					{
						if (JSON.stringify(body[key]) === JSON.stringify(editData[key]))
						{
							delete body[key];
						}
					});
					body.self = editData?.createdBy !== userData?.companyId;
					body.isActive = isActive;
					// need to always send isPublic, to update the visibility of post through backend
					body.isPublic = isPublic;
					res = await upatedFeedsAPI(body, query);
				}
				else if (requestT === 'repost')
				{
					// for repost creation only and not updating repost
					res = await repostFeedsAPI(body);
				}
				else
				{
					res = await createNewFeed(body);
				}

				if (res?.status)
				{
					if (requestT === 'editFeeds')
					{
						// on-edit-feed mode
						excludedS3KeysRef.current.forEach((key) => { s3DeleteNew(key, ''); });
						excludedS3KeysRef.current = [];
						const isBookmarked = editData?.bookMark;

						handleEditCallBack && handleEditCallBack({
							...res?.data,
							bookMark : isBookmarked
						});

						// to remove the feed from draft list when posting
						if (([ false ].includes(editData?.isActive) && isActive) ||
						// to remove feed from anywhere except from pending feeds screen if admin approval is required
							(requiresApproval && editData?.status !== 'pending')
						)
						{
							handleFeedAction && handleFeedAction('append', 'remove_feed', res?.data);
						}

						// to update feeds, bookmarks and popular feeds
						if ([ true ].includes(editData?.isActive) && isActive && !requiresApproval)
						{
							handleFeedAction && handleFeedAction('append', 'edit_feed', res?.data);
						}

						if (editData?.status === 'pending' && requiresApproval)
						{
							toast.success(language?.feedUpdatedSuccessfully || 'Feed updated successfully');
						}
						else if (requiresApproval && isActive)
						{
							toast.success(language?.feedSubmittedForApproval || 'Feed submitted for approval');
						}
						else if (requiresApproval && !isActive)
						{
							toast.success(language?.feedUpdatedSuccessfully || 'Feed updated successfully');
						}
						else
						{
							toast.success(`${language?.updatedFeedSucces}`);
						}
						// navigating from drafts screen to main news feed screen when feed is posted and approval is not required
						isActive && editData?.isActive === false && !requiresApproval && navigate('/news');
					}
					else
					{
						// on-create-feed mode
						if (createFeed?.media?.length > 0)
						{
							excludedS3KeysRef.current.forEach((key) => { s3DeleteNew(key, ''); });
							excludedS3KeysRef.current = [];
						}

						// for appending a new post which is not scheduled
						isActive && !requiresApproval && !isSchedule && handleFeedAction && handleFeedAction('append', 'new_feed', requestT === 'repost' ? res?.data : res?.feedResponse);

						isActive
							? requiresApproval
								? toast.success(language?.feedSubmittedForApproval || 'Feed submitted for approval')
								: toast.success(language?.newsCreated)
							: toast.success(`${language?.feedSaveDraft}`);

						requestT === 'driveUpload' && navigate('/news');

						const handleSearchFilterElement = document.getElementById('FeedTitleHeader');

						if (handleSearchFilterElement)
						{
							handleSearchFilterElement.style.display = 'flex';
						}
					}

					if (requestT === 'repost' && handleRepostCallback) handleRepostCallback(res?.data);
				}

				else
				{
					console.log(res, '-----------');
				}
				handleClosePop();
			}
			catch (err)
			{
				console.log(err);
				catchErr(err);
			}
			finally
			{
				setLoading(false);
			}
		}
	};

	const getDepartmentsList = async (skip = 0, limit = 50) =>
	{
		if (!userData?.companyId) return;

		try
		{
			const dquery = `?companyId=${userData.companyId}&empRole=${userData.empRole}&skip=${skip}&limit=${limit}&type=feed`;
			const departmentsData = await getDepartments(dquery);

			if (departmentsData && typeof departmentsData === 'object' && 'status' in departmentsData)
			{
				if (departmentsData.status)
				{
					if (skip === 0)
					{
						departmentsRef.current = departmentsData.data || [];
					}
					else
					{
						departmentsRef.current = [ ...departmentsRef.current, ...(departmentsData.data || []) ];
					}

					if (departmentsData?.data?.length === limit)
					{
						getDepartmentsList(skip + 1, limit);
					}

					// If editing and we have shareTo data, update createFeed with selected departments
					if (editData?._id && requestT === 'editFeeds' && editData?.shareTo)
					{
						const selectedDepartments = departmentsRef.current
							.filter((department) => editData.shareTo.includes(`${userData?.companyId}-${department.name}`))
							.map((dept) => `${userData?.companyId}-${dept.name}`);

						setCreateFeed((prev) => ({
							...prev,
							relations : prev.relations ? [ ...prev.relations.filter((rel) => typeof rel !== 'string'), ...selectedDepartments ] : selectedDepartments
						}));
					}
				}
			}
			else
			{
				departmentsRef.current = departmentsData || [];
			}
		}
		catch (error)
		{
			console.error('Error fetching departments:', error);
			departmentsRef.current = [];
		}
	};

	const handleChange = useCallback((value) =>
	{
		setCreateFeedAs(value);
		if (value === 'self' && createFeed?.relations?.length > 0) setCreateFeed((prev) => ({ ...prev, relations: [ internalEmpl ] }));
	}, [ createFeed?.relations ]);

	const getRelationsList = async () =>
	{
		const relationList = await getFeedRelations(relationsRef, setLoading);

		if (editData?._id && requestT === 'editFeeds')
		{
			let selectedRelation:any = [];

			if (editData?.isPublic)
			{
				selectedRelation = relationList;
			}
			else
			{
				selectedRelation = relationList?.filter((item) => editData?.shareTo?.includes(item?.relationId));
			}

			setCreateFeed((prev) => ({
				...prev,
				relations : prev.relations
					? [ ...selectedRelation, ...prev.relations.filter((rel) => typeof rel === 'string') ]
					: selectedRelation
			}));
		}
	};

	useEffect(() =>
	{
		userData.role !== 'individual' && getRelationsList();
		getCompanyConfigurations();
		getUserConfigurations();
	}, []);

	const handlePollData = useCallback((pollData) =>
	{
		setCreateFeed((prev) => ({ ...prev, poll: pollData }));
	}, []);

	const handleClickCancel = useCallback(() =>
	{
		disableFeedPost
			? handleClosePop()
			: setCancelPopup(true);
	}, [ handleClosePop, disableFeedPost ]);

	const value = useMemo(() => ({ createFeed, setCreateFeed }), [ createFeed, setCreateFeed ]);
	let minHeight:any;

	if (isReposting)
	{
		minHeight = '0px';
	}
	else if (footerAction === 'emoji')
	{
		minHeight = '420px';
	}
	else
	{
		minHeight = '300px';
	}

	return (
		<>
			{/* FeedContextProvider - Local Feed Data  */}
			<createFeedContext.Provider value={value}>
				<Dialog open={OpenPop} maxWidth='sm' fullWidth sx={{ height: 'var(--percent100)', overflowX: 'hidden' }}>
					{loading && <Loading/>}
					{/* CreateFeed Title Section... */}
					<CreateFeedHeader
						key={relationsRef.current}
						relations={createFeed?.relations}
						createFeedAs={createFeedAs}
						handleChange={handleChange}
						requestT={requestT}
						handleClickCancel={handleClickCancel}
						feedCreator={editData?.createdBy}
						relationsRef={relationsRef}
						departmentsRef={departmentsRef}
						getDepartmentsList={getDepartmentsList}
					/>
					{/* CreateFeed with text, media..etc */}
					<DialogContent sx={{ minHeight }}>
						{requiresApproval && <ApprovalNotice isEditMode={requestT === 'editFeeds' && editData?.isActive} />}
						<CreationContent
							editData={editData}
							requestT={requestT}
							isReposting={isReposting}
							excludedS3KeysRef={excludedS3KeysRef}
							addedPollData={createFeed?.poll ?? {}}
							handlePollData={handlePollData}
							cursorPositionRef={cursorPositionRef}
						/>
						{/* Feed Repost Section */}
						{isReposting &&
						<Grid item my='var(--pixel8)' xs={12}>
							<RepostCard
								parentData={requestT === 'editFeeds' ? editData?.repostObj : editData}
								noAction
								requestT={requestT}
							/>
						</Grid>}
					</DialogContent>

					{/* FeedFooter Section */}
					<DialogActions sx={{
						borderTop         : '1px solid #D7D7D7',
						padding           : 'var(--pixel16)',
						'& .MuiGrid-root' : {
							margin : 0
						}
					}}
					>
						<Grid
							container
							sx={{
								display                           : 'flex',
								flexWrap                          : 'wrap',
								alignItems                        : 'center',
								gap                               : 'var(--pixel16)',
								'& > .MuiGrid-item:first-of-type' : {
									flex : '1 1 auto'
								},
								'& > .MuiGrid-item:last-of-type' : {
									flex : '0 0 auto'
								}
							}}
						>
							<Grid item>
								<FooterActions
									requestT={requestT}
									handlePollData={handlePollData}
									externalFile={externalFile}
									footerAction={footerAction}
									setFooterAction={setFooterAction}
								/>
							</Grid>
							<Grid
								item
								sx={{
									display        : 'flex',
									justifyContent : 'flex-end'
								}}
							>
								<Stack
									direction={'row'}
									spacing={2}
									sx={{
										'& .MuiButton-root' : {
											minWidth   : 'fit-content',
											whiteSpace : 'nowrap'
										}
									}}
								>
									{((requestT === 'editFeeds' && editData?.isActive === false) || (requestT !== 'editFeeds' && !isSchedule)) &&
									<Button
										variant={'outlined'}
										onClick={() => handlePost(false)}
										disabled={disableFeedPost}
										className={`buttonoutlineBg ${disableFeedPost ? 'disableMode' : ''}`}
									>{language?.draft}</Button>}
									<Button
										variant={'contained'}
										sx={{ color: 'var(--whiteColor)' }}
										className={`buttonBg ${requestT === 'editFeeds' ? disablePost && 'disableMode' : disableFeedPost && 'disableMode'}`}
										disabled={loading || (requestT === 'editFeeds' ? disablePost : disableFeedPost)}
										onClick={() => handlePost(true)}
									>
										{requiresApproval
											? language?.submitForApproval || 'Submit for Approval'
											: requestT === 'editFeeds' && editData?.isActive
												? language?.update
												: language?.post}
									</Button>
								</Stack>
							</Grid>
						</Grid>
					</DialogActions>
					<NewDialogPopup // dialog for editing feeds
						open={cancelPopup && (requestT === 'editFeeds' || isSchedule)}
						showCross
						closeCallBack={() => { setCancelPopup(false); handleClosePop(); }}
						type={language.no}
						id={undefined}
						label={language?.discardMsg}
						from='feedCreate'
						formatType={language.yes}
						handleConfirm={() => setCancelPopup(false)}
						handleClose={() => setCancelPopup(false)}
					/>
					<NewDialogPopup // dialog for normal feeds asking for save as draft
						open={cancelPopup && (requestT !== 'editFeeds' && !isSchedule)}
						showCross
						closeCallBack={() => { setCancelPopup(false); handleClosePop(); }}
						type={language?.saveasdraft}
						id={undefined}
						label={language?.savepostdraft}
						from='feedCreate'
						formatType={language?.discard}
						handleConfirm={() => handlePost(false)}
						handleClose={() => setCancelPopup(false)}
					/>
				</Dialog>
			</createFeedContext.Provider>
		</>
	);
};

export default CreationFieldPopUp;